import { Download } from "lucide-react";
import KpiCard from "./charts/KpiCard";

/** Cohort metric with drill + CSV export (same handlers as before). */
export default function CohortCard({
  label,
  value,
  sub,
  icon,
  accent = "warning",
  onDrill,
  onExport,
}) {
  return (
    <div className="cohort-card">
      <KpiCard
        label={label}
        value={value}
        icon={icon}
        comparison={sub}
        accent={accent}
        onClick={onDrill}
        as={onDrill ? "button" : "div"}
        className="cohort-card-kpi"
      />
      {onExport ? (
        <button type="button" className="btn btn-sm cohort-card-export" onClick={onExport}>
          <Download size={14} strokeWidth={1.75} />
          Export CSV
        </button>
      ) : null}
    </div>
  );
}
